import {call, put} from "redux-saga/effects";
import * as api from "services/api";
import {loginError, loginSuccess} from "features/pages/account/login/reducer";
import {getErrorFromMessage} from "services/utils/utils";

export function* loginSaga({payload}) {
    try {
        const result = yield call([api, api.login], payload.email, payload.password);
        const data = {
            token: result.data.token,
            temp_password: result.data.temp_password,
            remember: payload.remember,
            onboarding_done: result.data.onboarding_done
        }
        yield put(loginSuccess(data));
    } catch (e) {
        yield put(loginError(getErrorFromMessage(e)));
    }
}